/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';
import Modal from 'react-awesome-modal';
import { I18n } from 'react-redux-i18n';
import moment from 'moment-timezone';

import NumbersHelper from '../../helpers/numbers';

const styles = {
  overlay: {
    fontFamily: "'Segoe UI', sans-serif",
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '12px',
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px 24px',
    borderBottom: '1px solid #e5e7eb',
    background: '#fff',
    borderRadius: '12px 12px 0 0',
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 700,
    color: '#111827',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  headerName: {
    color: '#4f46e5',
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    cursor: 'pointer',
    color: '#6b7280',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    lineHeight: 1,
  },
  body: {
    overflowY: 'auto',
    padding: '20px 24px',
    flex: 1,
    minHeight: 0,
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '12px',
    marginBottom: '24px',
  },
  infoCard: {
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '10px 14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
  },
  infoLabel: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  infoValue: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#111827',
  },
  statusActive: { color: '#16a34a' },
  statusInactive: { color: '#dc2626' },
  tableWrap: {
    overflowX: 'auto',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
    minWidth: '520px',
  },
  th: {
    padding: '10px 14px',
    background: '#f3f4f6',
    color: '#374151',
    fontWeight: 600,
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #e5e7eb',
    whiteSpace: 'nowrap',
    textAlign: 'left',
  },
  thRight: {
    padding: '10px 14px',
    background: '#f3f4f6',
    color: '#374151',
    fontWeight: 600,
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #e5e7eb',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  thCenter: {
    padding: '10px 14px',
    background: '#f3f4f6',
    color: '#374151',
    fontWeight: 600,
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #e5e7eb',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '10px 14px',
    color: '#374151',
    borderBottom: '1px solid #f3f4f6',
    verticalAlign: 'middle',
  },
  tdRight: {
    padding: '10px 14px',
    color: '#374151',
    borderBottom: '1px solid #f3f4f6',
    textAlign: 'right',
    verticalAlign: 'middle',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  },
  tdCenter: {
    padding: '10px 14px',
    color: '#374151',
    borderBottom: '1px solid #f3f4f6',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  codeChip: {
    display: 'inline-block',
    background: '#ede9fe',
    color: '#5b21b6',
    borderRadius: '4px',
    padding: '2px 7px',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.03em',
  },
  qtyBadge: {
    display: 'inline-block',
    background: '#f3f4f6',
    color: '#374151',
    borderRadius: '12px',
    padding: '2px 10px',
    fontSize: '13px',
    fontWeight: 600,
    minWidth: '32px',
    textAlign: 'center',
  },
  originalPrice: {
    color: '#9ca3af',
    textDecoration: 'line-through',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  },
  newPrice: {
    color: '#16a34a',
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  },
  totalsBox: {
    marginTop: '16px',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 18px',
    background: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
  },
  totalRowHighlight: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 18px',
    background: '#ede9fe',
  },
  totalLabel: {
    fontSize: '14px',
    color: '#6b7280',
    fontWeight: 500,
  },
  totalValue: {
    fontSize: '14px',
    color: '#374151',
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  totalLabelHL: {
    fontSize: '15px',
    color: '#4f46e5',
    fontWeight: 700,
  },
  totalValueHL: {
    fontSize: '18px',
    color: '#4f46e5',
    fontWeight: 800,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
  },
  noData: {
    textAlign: 'center',
    padding: '32px',
    color: '#9ca3af',
    fontSize: '14px',
  },
  descriptionCell: {
    color: '#111827',
    fontWeight: 500,
    maxWidth: '240px',
    wordBreak: 'break-word',
  },
};

function PackDetailModal({ visible, pack, closeModal }) {
  if (!pack) return null;

  const items = pack.packsProducts || [];
  const fmt = val => NumbersHelper.toCurrency(val || 0);

  const savings = (pack.totalOriginal || 0) - (pack.totalCurrent || 0);
  const savingsPct = pack.totalOriginal
    ? Math.round((savings / pack.totalOriginal) * 100)
    : 0;

  return (
    <Modal
      visible={visible}
      width="860px"
      height="90vh"
      effect="fadeInDown"
      onClickAway={closeModal}
    >
      <div style={styles.overlay}>
        <div style={styles.header}>
          <h4 style={styles.headerTitle}>
            <span>
              {I18n.t('packDetails')}
              {': '}
              <span style={styles.headerName}>{pack.name}</span>
            </span>
          </h4>
          <button
            type="button"
            style={styles.closeBtn}
            onClick={closeModal}
            title="Cerrar"
          >
            ✕
          </button>
        </div>

        <div style={styles.body}>
          {pack.imageUrl && (
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img
                src={pack.imageUrl}
                alt={pack.name}
                style={{
                  maxWidth: '100%',
                  maxHeight: '220px',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                }}
              />
            </div>
          )}

          {pack.description && (
            <div style={{
              background: '#f9fafb',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '12px 16px',
              marginBottom: '20px',
              fontSize: '14px',
              color: '#374151',
              lineHeight: 1.6,
            }}
            >
              {pack.description}
            </div>
          )}

          <div style={styles.infoGrid}>
            <div style={styles.infoCard}>
              <span style={styles.infoLabel}>{I18n.t('dateEffective')}</span>
              <span style={styles.infoValue}>
                {pack.dateEffective
                  ? moment(pack.dateEffective).format('DD/MM/YYYY')
                  : '—'}
              </span>
            </div>
            <div style={styles.infoCard}>
              <span style={styles.infoLabel}>{I18n.t('dateExpiration')}</span>
              <span style={styles.infoValue}>
                {pack.dateExpiration
                  ? moment(pack.dateExpiration).format('DD/MM/YYYY')
                  : '—'}
              </span>
            </div>
            <div style={styles.infoCard}>
              <span style={styles.infoLabel}>{I18n.t('status')}</span>
              <span
                style={{
                  ...styles.infoValue,
                  ...(pack.status ? styles.statusActive : styles.statusInactive),
                }}
              >
                {pack.status ? `${I18n.t('active2')}` : `${I18n.t('inactive')}`}
              </span>
            </div>
            <div style={styles.infoCard}>
              <span style={styles.infoLabel}>{I18n.t('sales')}</span>
              <span style={styles.infoValue}>{pack.sales || 0}</span>
            </div>
            {savings > 0 && (
              <div
                style={{
                  ...styles.infoCard,
                  background: '#f0fdf4',
                  border: '1px solid #bbf7d0',
                }}
              >
                <span style={{ ...styles.infoLabel, color: '#16a34a' }}>Ahorro</span>
                <span style={{ ...styles.infoValue, color: '#16a34a' }}>
                  {fmt(savings)}
                  {' '}
                  <span style={{ fontSize: '12px', fontWeight: 500 }}>
                    (
                    {savingsPct}
                    {'%)'}
                  </span>
                </span>
              </div>
            )}
          </div>

          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>{I18n.t('product')}</th>
                  <th style={styles.th}>{I18n.t('code')}</th>
                  <th style={styles.thCenter}>
                    {I18n.t('quantity').trim().replace(':', '')}
                  </th>
                  <th style={styles.thRight}>{I18n.t('originalPrice')}</th>
                  <th style={styles.thRight}>{I18n.t('newPrice')}</th>
                  <th style={styles.thRight}>{I18n.t('subtotal')}</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={styles.noData}>
                      {I18n.t('noData')}
                    </td>
                  </tr>
                ) : (
                  items.map((item, idx) => {
                    const code = item.product && item.product.code;
                    const description = item.product && item.product.description;
                    return (
                      <tr
                        key={code || `item-${idx}`}
                        style={{
                          background: idx % 2 === 0 ? '#fff' : '#fafafa',
                        }}
                      >
                        <td style={{ ...styles.td, ...styles.descriptionCell }}>
                          {description || '—'}
                        </td>
                        <td style={styles.td}>
                          <span style={styles.codeChip}>{code || '—'}</span>
                        </td>
                        <td style={styles.tdCenter}>
                          <span style={styles.qtyBadge}>{item.quantity}</span>
                        </td>
                        <td style={styles.tdRight}>
                          <span style={styles.originalPrice}>
                            {fmt(item.originalUnitPrice)}
                          </span>
                        </td>
                        <td style={styles.tdRight}>
                          <span style={styles.newPrice}>
                            {fmt(item.currentUnitPrice)}
                          </span>
                        </td>
                        <td style={{ ...styles.tdRight, fontWeight: 600 }}>
                          {fmt(item.currentSubtotal)}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div style={styles.totalsBox}>
            <div style={styles.totalRow}>
              <span style={styles.totalLabel}>{I18n.t('totalOriginal')}</span>
              <span style={styles.totalValue}>{fmt(pack.totalOriginal)}</span>
            </div>
            <div style={styles.totalRowHighlight}>
              <span style={styles.totalLabelHL}>{I18n.t('totalCurrent')}</span>
              <span style={styles.totalValueHL}>{fmt(pack.totalCurrent)}</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PackDetailModal;
